var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style, undefined) {
buf.push("<div" + (jade.cls([style.container], [true])) + "><div" + (jade.cls([style.modal], [true])) + "><header>&nbsp;</header><section>" + (null == (jade_interp = require("/Users/nmd/dev/vsct.info/src/js/components/order-ukp-kleshiha/template.jade").call(this, locals)) ? "" : jade_interp) + "</section><a href=\"#close\" v-on=\"click: onClick\"" + (jade.cls([style.close], [true])) + ">&#215;</a></div></div>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/order-ukp-kleshiha/modal.jade
 ** module id = 182
 ** module chunks = 0
 **/